
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Save, Trash2 } from 'lucide-react';
import ProductShareLink from './ProductShareLink';
import { Product } from '@/lib/supabase/products/types';

interface ProductHeaderActionsProps {
  onBack: () => void;
  onSave: () => void;
  onDelete?: () => void;
  saving: boolean;
  isNew: boolean;
  product?: Product;
}

const ProductHeaderActions = ({
  onBack,
  onSave,
  onDelete,
  saving,
  isNew,
  product
}: ProductHeaderActionsProps) => {
  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onBack}
        className="mr-auto"
      >
        <ArrowLeft className="h-4 w-4 mr-1" />
        Retour
      </Button>
      
      {!isNew && product && <ProductShareLink product={product} />}
      
      <Button
        size="sm"
        onClick={onSave}
        disabled={saving}
      >
        <Save className="h-4 w-4 mr-1" />
        {saving ? 'Enregistrement...' : 'Enregistrer'}
      </Button>
      
      {!isNew && onDelete && (
        <Button
          variant="destructive"
          size="sm"
          onClick={onDelete}
        >
          <Trash2 className="h-4 w-4 mr-1" />
          Supprimer
        </Button>
      )}
    </div>
  );
};

export default ProductHeaderActions;
